import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Draggable from 'react-draggable';
import { IImageThumbnail } from '../../../Entities';
import { useApiUrl } from '../../../../../../../shared/hooks/useApiUrl';
import { PREVIEW_HEIGHT, PREVIEW_WIDTH } from '../state/utils';
import { ImageLoadingSkeleton } from '../../../shared/imageCard/view/ImageLoadingSkeleton';

type StitchImagePreviewProps = {
    image: IImageThumbnail;
    alt: string;
    dragBoundY: number;
    onDragStop: (_e: unknown, data: { y: number }) => void;
};

const ImageContainer = styled(Box)({
    position: 'relative',
    overflow: 'hidden',
    width: PREVIEW_WIDTH,
    height: PREVIEW_HEIGHT,
    backgroundColor: '#cdd3d3',
    borderRadius: '4px',
    flexShrink: 0
});

const StitchImage = styled('img')<{ loaded: boolean }>(({ loaded }) => ({
    width: PREVIEW_WIDTH,
    display: 'block',
    opacity: loaded ? 1 : 0,
    transition: 'opacity 200ms ease'
}));

const SkeletonWrapper = styled(Box)({
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

export function StitchImagePreview({ image, alt, dragBoundY, onDragStop }: StitchImagePreviewProps) {
    const apiUrl = useApiUrl();
    const [isLoaded, setIsLoaded] = React.useState(false);

    return (
        <ImageContainer>
            {!isLoaded && (
                <SkeletonWrapper>
                    <ImageLoadingSkeleton />
                </SkeletonWrapper>
            )}
            <Draggable
                axis="y"
                bounds={{ left: 0, top: -dragBoundY, right: 0, bottom: 0 }}
                defaultPosition={{ x: 0, y: 0 }}
                onStop={onDragStop}
            >
                <StitchImage
                    src={apiUrl + '/file/' + image.highResolutionImageReference}
                    alt={alt}
                    draggable={false}
                    loaded={isLoaded}
                    onLoad={function () {
                        setIsLoaded(true);
                    }}
                />
            </Draggable>
        </ImageContainer>
    );
}